// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"285":"ac04aaa1","303":"c7c7e4e7"}[chunkId] + ".chunk.css";
};